import React from 'react';

import Zoom from 'components/Builder/Zoom';
import Rule from 'components/Builder/Rule';
import ModalSetting from 'components/Settings/ModalSetting';
import ExportGroup from 'components/Builder/ExportGroup';
import useGroup from "../../hooks/useGroup";

const emptyFunction = () => {
};

function ToolsSetting(props) {
	let {
		zoom = {
			currentZoom: 1,
			setCurrentZoom: emptyFunction
		},
		setActive,
		active,
		disabled,
		wrapper,
		reducedMap,
		setReducedMap,
		setFetchingGroup
	} = props;


	const {
		moveGroup
	} = useGroup();

	return (
		<div className={'settings-buttons-container' + (reducedMap ? ' with-map-button' : '')} id="Tools-Setting">
			<Zoom
				currentZoom={zoom.currentZoom}
				setCurrentZoom={zoom.setCurrentZoom}
				active={!moveGroup}
			/>
			<Rule
				active={active === 2}
				setActive={setActive}
				disabled={disabled}
				wrapper={wrapper}
				currentZoom={zoom.currentZoom}
			/>
			<ExportGroup
				disabled={disabled}
			/>
			<ModalSetting
				setFetchingGroup={setFetchingGroup}
				disabled={disabled}
			/>

			{reducedMap && (
				<button
					type="button"
					className="btntool btn btn-primary p-0 openmap"
					onClick={() => {
						setReducedMap(false);
					}}>
					<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none"
					     strokeLinecap="round" strokeLinejoin="round"
					>
						<polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon>
						<line x1="8" y1="2" x2="8" y2="18"></line>
						<line x1="16" y1="6" x2="16" y2="22"></line>
					</svg>
				</button>
			)}
		</div>
	);
}

export default ToolsSetting;
